import type { ChatModelId } from './providers';

export const DEFAULT_MODEL_ID: ChatModelId = 'gpt-5.4-nano';
// Worst-case turn: MAX_SEARCHES searches + suggestRefinements + the reply step,
// with headroom. Must stay > MAX_SEARCHES + 2 so the flow always reaches the reply.
export const MAX_STEPS = 6;
// Cap on searchSuppliers calls per turn: the initial search plus the re-searches
// the model may choose (refine weak/zero results, or retry an errored search)
// before suggestRefinements is forced.
export const MAX_SEARCHES = 3;

// Message-gate limits (see sanitize-messages.ts).
export const MAX_MESSAGES = 50;
export const MAX_TEXT_PART_CHARS = 4_000;
export const MAX_TOTAL_TEXT_CHARS = 24_000;

/** Schema/contract version reported on the `AI Prompt Sent` BigQuery event. */
export const AI_SEARCH_VERSION = 'v1';

// Initial-prompt results validation
export const INITIAL_PROMPT_DISPLAY_COUNT = 3;
export const INITIAL_PROMPT_MIN_RESULTS = 1;
// radiusIncrease km on top of the default 40km. null = default (~30 min). Order = escalation order.
// One widen step only: a venue an hour-plus away is a poor suggestion, not a good one.
export const PROMPT_RADIUS_STEPS: (number | null)[] = [null, 80];
